<div>
    <h2>{{'mantenimiento-entidades-control.titulo' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'global.pais' | translate}} </label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-entidades-control.filters.denominacion' | translate}}</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-entidades-control.filters.entidad' | translate}}</label>
                <input type="text" formControlName="des">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-entidades-control.filters.auditores' | translate}}</label>
                <app-filterable-list [itemsList]="auditores" [selectedItem]="filtersForm.get('auditor')"
                    [disabled]="disabledAuditores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimiento-entidades-control.filters.integradores' | translate}}</label>
                <app-filterable-list [itemsList]="integradores" [selectedItem]="filtersForm.get('integrador')"
                    [disabled]="disabledIntegradores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="radio-group move-left-next">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id sortable" (click)="toOrderBy('x=> x.id', 1)">
                          {{'mantenimiento-entidades-control.table.id' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.id')"></i></div>
                        </th>
                        <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.des', 2)">
                          {{'mantenimiento-entidades-control.table.entidad' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.des')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 3)">
                          {{'global.fecha.insercionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 4)">
                          {{'global.fecha.actualizacionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaUpd')"></i></div>
                        </th>
                        <!-- Mostrar todo el módulo de Expediciones (Expediciones, Certificados, Trazabilidad Certificado) en el sidebar -->
                        <th class="icon">{{'global.moduloCertificado' | translate }}</th>
                        <th class="string" [innerHTML]="'global.limiteBloqueoAutomaticoCertificado' | translate"></th>
                        <th class="action">
                            <i class="fas fa-plus" (click)="create()" title="{{'mantenimiento-entidades-control.tituloNew' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <tbody *ngFor="let entidad of entidadesControl; let i = index; trackBy: trackByEntidadId">
                    <tr>
                        <td class="id">{{entidad.id}}</td>
                        <td class="string-longest">{{entidad.des}}</td>
                        <td class="date">{{entidad.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date">{{entidad.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="icon">
                            <input id="{{'modoEtiquetas' + i}}" type="checkbox" [checked]="entidad.mostrarMenuExpedicion" disabled>
                            <label for="{{'modoEtiquetas' + i}}" style="margin-bottom: unset;"></label>
                        </td>
                        <td class="string">{{entidad.porcentajeCertExpBloqAuto}}%</td>
                        <td class="multi-actions">
                            <i class="fas fa-stream" (click)="openTabs(i)" title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                            <i class='fas fas fa-pencil-alt' title="{{'titles.editar' | translate}}" (click)="update(entidad)" title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" [ngClass]="{'disabled': (entidad.registroEnUso)}"
                                (click)="askDelete(entidad)" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="7">
                            <section class="tabs">
                                <ul>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showPaisDenominacion(i)">{{'mantenimiento-entidades-control.denominaciones.titulo' | translate}}</li>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showAuditores(i)">{{'mantenimiento-entidades-control.auditores.titulo' | translate}}</li>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 3}" (click)="showRoyalties(i)">{{'mantenimiento-entidades-control.royalties.titulo' | translate}}</li>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 4}" (click)="showBlockchain(i)">{{'global.blockchain.informacion.blockchain' | translate}}</li>
                                </ul>
                                <content>
                                    <app-mec-pais-denominacion *ngIf="pestanaActiva[i] === 1" [entidadControlId]="entidad.id" [paises]="paises" (refresh)="refresh($event)" (pushMessage)="pushMessage($event)">País-Denominación</app-mec-pais-denominacion>
                                    <app-auditores-entidad *ngIf="pestanaActiva[i] === 2" [entidadControl]="entidad"></app-auditores-entidad>
                                    <app-royalties-entidad *ngIf="pestanaActiva[i] === 3" [entidadControl]="entidad" (refresh)="refresh($event)" (pushMessage)="pushMessage($event)"></app-royalties-entidad>
                                    <app-blockchain-entidad *ngIf="pestanaActiva[i] === 4" [entidadControl]="entidad" (refresh)="refresh($event)" (pushMessage)="pushMessage($event)"></app-blockchain-entidad>
                                </content>
                            </section>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!entidadesControl || (entidadesControl && entidadesControl.length < 1)">
                    <tr>
                      <td colspan="7">
                        {{'global.noContent' | translate}}
                      </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="entidadesControl && entidadesControl.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
        <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
      <header>
        <h4>{{entidadControl ? ('mantenimiento-entidades-control.tituloEdit' | translate) : ('mantenimiento-entidades-control.tituloNew' | translate)}}</h4>
      </header>
      <app-mantenimiento-ec-new-edit [entidadControl]="entidadControl" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
      </app-mantenimiento-ec-new-edit>
    </div>
</div>
